import Auth from '@js/plugins/auth';

export default {
    computed: {
        canManageOrderLayout() {
            return Auth.hasPermissionTo('franchise_manage_settings');
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/order-layout/order-layout-permission.js